module.exports = __webpack_public_path__ + "static/media/SilverMedal.fec3e9a6.png";